export enum CardDisplayType {
  checklist = 'checklist',
  compact = 'compact',
  detailed = 'detailed',
  medium = 'medium',
  reminder = 'reminder',
}
